<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.4776 6H19C20.6569 6 22 7.34315 22 9V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H10.3837C10.6857 4 10.9716 4.13652 11.1614 4.37144L12.4776 6ZM9.90609 6H5C4.44772 6 4 6.44772 4 7V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V9C20 8.44772 19.5523 8 19 8H12C11.698 8 11.4121 7.86348 11.2222 7.62856L9.90609 6ZM15 10C14.4477 10 14 10.4477 14 11V12H13C12.4477 12 12 12.4477 12 13C12 13.5523 12.4477 14 13 14H14V15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15V14H17C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12H16V11C16 10.4477 15.5523 10 15 10Z"
    fill="currentColor"
  />
</svg>
